export default function urlTratador(string) {
    let textTratado = string.split(' ')
    textTratado = textTratado.join('-')
    return textTratado.toLowerCase()
}